import { render, staticRenderFns } from "./ddzTable.vue?vue&type=template&id=118c0c82&scoped=true"
import script from "./ddzTable.vue?vue&type=script&lang=ts"
export * from "./ddzTable.vue?vue&type=script&lang=ts"
import style0 from "./ddzTable.vue?vue&type=style&index=0&id=118c0c82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118c0c82",
  null
  
)

export default component.exports